/**
 * Asset Management Service Hooks
 * React hooks for accessing asset management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all asset-management services. */
export function useAssetManagementServices() {
    const { services } = useCCMS();
    if (!services?.assetManagement) {
        throw new Error('Asset Management services not available. Ensure CCMSProvider is configured.');
    }
    return services.assetManagement;
}
export function useAssetService() {
    return useAssetManagementServices().asset;
}
export function useAssetScanService() {
    return useAssetManagementServices().assetScan;
}
export function useAssetSettingsService() {
    return useAssetManagementServices().assetSettings;
}
export function useAssetStatusService() {
    return useAssetManagementServices().assetStatus;
}
export function useAssetCategoryService() {
    return useAssetManagementServices().assetCategory;
}
export function useAssetTypeService() {
    return useAssetManagementServices().assetType;
}
export function useAssetConditionService() {
    return useAssetManagementServices().assetCondition;
}
export function useAssetAssignmentTypeService() {
    return useAssetManagementServices().assetAssignmentType;
}
export function useAssetScanTypeService() {
    return useAssetManagementServices().assetScanType;
}
export function useAssetScanPurposeService() {
    return useAssetManagementServices().assetScanPurpose;
}
export function useAssetTagTypeService() {
    return useAssetManagementServices().assetTagType;
}
export function useMaintenanceTypeService() {
    return useAssetManagementServices().maintenanceType;
}
export function useDepreciationMethodService() {
    return useAssetManagementServices().depreciationMethod;
}
export function useAssetLogTypeService() {
    return useAssetManagementServices().assetLogType;
}
export function useAssetEntrancePointService() {
    return useAssetManagementServices().assetEntrancePoint;
}
//# sourceMappingURL=useAssetManagementServices.js.map